import React from 'react';
import gql from 'graphql-tag';
import GqlAutocomplete from './GqlAutocomplete';
import { joinDefined } from '../../utils/strings';

const PlaqueOrderAutoComplete = ({ category, className, name, clearOnSelect = false, ...props }) => {
    return (
        <GqlAutocomplete
            className={className}
            readAllQuery={readAllPlaqueOrders}
            placeholder="Plaque order..."
            labelFieldFunc={e =>
                joinDefined(
                    [
                        e.LegacyKey,
                        '-',
                        e.NameOfDeceased ||
                            (e.Deceased && e.Deceased.FirstName,
                            e.Deceased && e.Deceased.MiddleName,
                            e.Deceased && e.Deceased.Surname)
                    ],
                    ' '
                )
            }
            multiple={false}
            name={name}
            clearOnSelect={clearOnSelect}
            {...props}
        />
    );
};

const readAllPlaqueOrders = gql`
    fragment AllPlaqueOrderFragment on PlaqueOrder {
        ID
        LegacyKey
        NameOfDeceased
        Deceased {
            ID
            FirstName
            Surname
        }
    }

    query ReadPlaqueOrders($contains: String) {
        readPlaqueOrders(contains: $contains, limit: 5, offset: 0) {
            edges {
                node {
                    ...AllPlaqueOrderFragment
                }
            }
        }
    }
`;

export default PlaqueOrderAutoComplete;
